<script setup lang="ts">
import type { MetadataDetector, MetadataType } from "@/types";
import { computed } from "vue";
import DRBtnAI from "../UI/DRBtnAI.vue";

const props = defineProps<{
  modelValue?: MetadataType;
  suggestion?: MetadataType;
  metadataDetector: MetadataDetector;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: MetadataType): void;
  (e: "blur"): void;
}>();

const value = computed({
  get: () => props.modelValue,
  set: (val: MetadataType) => emit("update:modelValue", val),
});
</script>

<template>
  <div class="d-flex flex-column gap-1">
    <div
      class="d-flex flex-row gap-2 justify-content-between align-items-center"
    >
      <div>
        <span class="fw-medium">{{
          metadataDetector.label?.length
            ? metadataDetector.label
            : metadataDetector.prompt
        }}</span>
      </div>
      <div class="col-auto" v-if="suggestion && suggestion !== modelValue">
        <el-tooltip :content="suggestion" effect="light" placement="top">
          <DRBtnAI @click="value = suggestion" :label="$t('recommendation')" />
        </el-tooltip>
      </div>
    </div>

    <div class="d-flex flex-row gap-2 align-items-center">
      <el-input
        class="col"
        size="large"
        v-model="value"
        :type="modelValue && modelValue.length > 80 ? 'textarea' : 'text'"
        :placeholder="$t('set.value')"
        @blur="() => emit('blur')"
      >
      </el-input>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/variables.scss";
.ia-button {
  color: var(--bs-ia);
  font-size: 12px;
  background-color: transparent;
  border: 1px solid rgba($ia, 0.1);
  transition: all 0.2s ease;
  &:hover {
    background-color: $ia;
    color: white;
  }
}
</style>
